import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Card, Button, IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import WrapperSeamless from '../../layout-components/WrapperSeamless';
import * as Api from '../../service';
import useStore from '../../context';

const SeoList = () => {
  const { setRemove, setErrorMsg } = useStore();
  const [pages, setPages] = useState([]);

  const loadPages = useCallback(() => {
    Api.seo.getAll()
      .then((res) => setPages(Array.isArray(res) ? res : res?.items || []))
      .catch((e) => setErrorMsg(e.message));
  }, [setErrorMsg]);

  useEffect(loadPages, [loadPages]);

  return (
    <Container>
      <WrapperSeamless sectionHeading="SEO — Page Meta">
        <Card className="shadow-xxl px-4 py-3">
          <div className="d-flex justify-content-end mb-2">
            <Button component={Link} to="/seo/create" className="btn-primary">
              Add Page
            </Button>
          </div>
          <div className="table-responsive">
            <table className="table table-hover text-nowrap mb-0">
              <thead>
                <tr>
                  <th>Path</th>
                  <th>Meta Title</th>
                  <th>Meta Description</th>
                  <th>Updated</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {pages.map((page) => (
                  <tr key={page.id}>
                    <td>{page.pagePath}</td>
                    <td style={{ maxWidth: 280, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {page.metaTitle}
                    </td>
                    <td style={{ maxWidth: 360, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {page.metaDescription}
                    </td>
                    <td>{page.updatedAt ? new Date(page.updatedAt).toLocaleDateString() : ''}</td>
                    <td>
                      <IconButton component={Link} to={`/seo/create/${page.id}`} size="small">
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() =>
                          setRemove(() => () => Api.seo.delete(page.id).then(loadPages))
                        }>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      </WrapperSeamless>
    </Container>
  );
};

export default SeoList;
